module.exports = __webpack_public_path__ + "assets/img/wallet-icon1.4b19bc6b.png";